import I18n from '~/src/common/services/I18n';

import styles from './PortionsText.module.scss';

const PortionsText = ({ portions }: { portions: number }) => (
  <p className={styles.portionsText}>
    <span>{portions}</span>
    <span>{I18n.t('recipe-screen.portion-picker', { count: portions })}</span>
  </p>
);

export default PortionsText;
